import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { RegionSchema } from '../../base/region.js';
export const ListAllRegionsApiSchema = {
    headers: ApiLambdalerAuthHeaderSchema,
    response: z.object({
        regions: RegionSchema.array(),
    }),
};
